/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReportSnapshotShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path
          clipRule="evenodd"
          d="M8.5 2a6.5 6.5 0 0 0-4.578 11.114l1.409-1.42A4.502 4.502 0 0 1 7.5 4.112v5.496l5.28-2.599c.117.318.2.652.242.997l1.985-.244C14.614 4.549 11.823 2 8.5 2zm1 4.393V4.114c.833.193 1.586.62 2.182 1.206z"
          fillRule="evenodd"
        />
        <path d="M16.414 9h-4.828l-2 2H6v4h2v-2h2.414l2-2h3.172l2 2H20v7H7v2h15V11h-3.586z" />
        <path
          clipRule="evenodd"
          d="M14 13a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"
          fillRule="evenodd"
        />
        <path d="M2.474 17.474 1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgReportSnapshotShortcut as ReportSnapshotShortcut };
